import { ChecklistUploaderContainer } from "./ChecklistUploaderWidget.styles.js";
import Title from "../../../../components/widgets/components/title/Title.js";

const COMMANDS = [
    { label: 'List all series',              cmd: 'node scripts/upload-checklist.js --list' },
    { label: 'Upload checklist + parallels', cmd: 'node scripts/upload-checklist.js "<series title>"' },
    { label: 'Upload checklist only',        cmd: 'node scripts/upload-checklist.js "<series title>" --checklist' },
    { label: 'Upload parallels only',        cmd: 'node scripts/upload-checklist.js "<series title>" --parallels' },
    { label: 'Target production',            cmd: 'node scripts/upload-checklist.js "<series title>" --env production' },
];

export default function ChecklistUploaderWidget() {
    return (
        <ChecklistUploaderContainer className="widget-bg">
            <Title text={"CHECKLIST MANAGER"} />

            <div style={{ padding: '12px 4px' }}>
                <p style={{ marginBottom: 16, lineHeight: 1.5 }}>
                    Checklist uploads are now handled via a local CLI script to keep
                    data files out of the production bundle.
                    Run the following commands from the <strong>project root</strong>:
                </p>

                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <tbody>
                        {COMMANDS.map(({ label, cmd }) => (
                            <tr key={cmd} style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                                <td style={{ padding: '8px 12px 8px 0', opacity: 0.6, whiteSpace: 'nowrap' }}>
                                    {label}
                                </td>
                                <td style={{ padding: '8px 0' }}>
                                    <code style={{
                                        display: 'block',
                                        background: 'rgba(0,0,0,0.35)',
                                        borderRadius: 4,
                                        padding: '4px 8px',
                                        fontFamily: 'monospace',
                                        fontSize: 12,
                                        wordBreak: 'break-all',
                                    }}>
                                        {cmd}
                                    </code>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <p style={{ marginTop: 16, opacity: 0.5, fontSize: 12, lineHeight: 1.5 }}>
                    See <code style={{ fontFamily: 'monospace' }}>scripts/upload-checklist.js</code> for
                    full documentation and instructions for adding new series.
                </p>
            </div>
        </ChecklistUploaderContainer>
    );
}
